export default __webpack_public_path__ + "static/media/stay-connected.ed138b86.jpg";